var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.organization ? _c('ModelEditor', {
    attrs: {
      "title": _vm.title,
      "model": _vm.organization,
      "errors": _vm.errors,
      "loading": _vm.$apollo.loading,
      "canSave": _vm.isDirty,
      "canCancel": _vm.isDirty
    },
    on: {
      "save": _vm.save,
      "cancel": _vm.restore
    }
  }, [_vm.organization ? _c('OrganizationStyled', [_c('AutoForm', {
    attrs: {
      "model": _vm.organization,
      "modelName": 'Organization',
      "filterFields": _vm.filterFields
    },
    on: {
      "update:model": function updateModel($event) {
        _vm.organization = $event;
      }
    }
  }), _c('ModelAssociator', {
    attrs: {
      "title": 'Assets',
      "models": _vm.assets,
      "sourceModelName": 'organization',
      "targetModelName": 'asset',
      "targetModelNamePlural": 'machines',
      "whereSearchInputType": 'MachineFilterInput',
      "canBulkAddAssets": true
    },
    on: {
      "connect": _vm.addAsset,
      "disconnect": _vm.confirmAssetDeletion
    }
  }, [_c('template', {
    slot: "bulkAddAssets"
  }, [_c('PasteIds', {
    attrs: {
      "mode": 'addAssetsToOrganization'
    },
    on: {
      "refetch": _vm.refetch
    }
  })], 1)], 2), _c('MembershipManager', {
    attrs: {
      "title": 'Members',
      "memberships": _vm.organization.memberships,
      "options": _vm.membershipMananagerOptions,
      "targetId": _vm.organizationId,
      "subsidiaries": _vm.organization.subsidiaries
    }
  }), _c('SubsidiariesManager', {
    attrs: {
      "organization": _vm.organization
    }
  }), _c('ConfidentialClientManager', {
    attrs: {
      "title": 'Confidential Clients',
      "targetId": _vm.organizationId
    }
  }), _c('AcquisitionsManager', {
    attrs: {
      "organization": _vm.organization
    }
  })], 1) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }